import React from "react";
import { jsx } from "slate-hyperscript";
import {
    InlineHandler, StyleType,
} from "./base";

InlineHandler.register(StyleType.STRIKETHROUGH, {
    nodeTypes: ["DEL"],
    toBlock: child => <del>{child}</del>,
    serialize: child => `<del>${child}</del>`,
    deserialize: children => jsx("text", { ...children, [StyleType.STRIKETHROUGH]: Object.create(null) }),
});
